import { TrialBalanceLowMessage, TrialExpiringTopHeaderMessage } from "@callcenter-frontend/self-service"

import { ApiDeprecationBanner } from "../api-deprecation-banner"
import { BrowserSupportWarning } from "../browser-support-warning"
import { SupportWarning } from "../support-warning"
import { TermsOfService } from "../terms-of-service"

type Modules =
  | "tos"
  | "trial-expiring-message"
  | "trial-balance-low-message"
  | "browser-support-warning"
  | "support-warning"
  | "api-deprecation-banner"

type TopHeaderModulesProps = {
  hideModules?: Array<Modules>
}
export const TopHeaderModules = ({ hideModules = [] }: TopHeaderModulesProps) => (
  <>
    {!hideModules.includes("tos") && <TermsOfService />}
    {!hideModules.includes("trial-balance-low-message") && <TrialBalanceLowMessage />}
    {!hideModules.includes("trial-expiring-message") && <TrialExpiringTopHeaderMessage />}
    {!hideModules.includes("browser-support-warning") && <BrowserSupportWarning />}
    {!hideModules.includes("support-warning") && <SupportWarning />}
    {!hideModules.includes("api-deprecation-banner") && <ApiDeprecationBanner />}
  </>
)
